import styled from "styled-components";
import { LIGHT_GRAY, WHITE } from "../../index.style.ts";

export const Wrapper = styled.div`
  position: relative;
  height: 320px;
  background: ${WHITE};
  border: 1px solid ${LIGHT_GRAY};
  border-radius: 12px;
  padding: 16px;

  @media only screen and (max-width: 800px) {
    height: 260px;
    padding: 10px;
  }
`;
